import * as PropTypes from 'prop-types';
import { addMonths, format } from 'date-fns';
import cx from 'classnames';
import Input from '../../atoms/Input';
import Button from '../../atoms/Button';

const FormInvoiceTicket = ({
    className,
    isLoading,
    ticketValues,
    ticketStatus,
    setTicketValues,
    handleConsultTicket,
    handleResetValues,
    children,
}) => {
    const minDate = format(addMonths(new Date(), -1), 'yyyy-MM-dd');
    const maxDate = format(new Date(), 'yyyy-MM-dd');

    return (
        <form
            onSubmit={(e) => handleConsultTicket(e)}
            className={cx(className, 'grid w-full grid-cols-2 gap-4')}
        >
            {/* STORE ID */}
            <Input
                id='store-Id'
                key='storeId'
                name='store id'
                className='col-span-2 lg:col-span-1'
                label='Sucursal'
                type='number'
                placeholder='728'
                value={ticketValues.storeId}
                onChange={(e) => setTicketValues({ ...ticketValues, storeId: e })}
                required
            />

            {/* TICKET NUMBER */}
            <Input
                id='ticket-number'
                key='ticketNumber'
                name='ticket number'
                className='col-span-2 lg:col-span-1'
                label='Num. Ticket'
                type='number'
                placeholder='123'
                value={ticketValues.ticketId}
                onChange={(e) => setTicketValues({ ...ticketValues, ticketId: e })}
                required
            />

            {/* REGISTER */}
            <Input
                id='register'
                key='register'
                name='register'
                className='col-span-2 lg:col-span-1'
                label='Caja'
                type='number'
                placeholder='03'
                value={ticketValues.posId}
                onChange={(e) => setTicketValues({ ...ticketValues, posId: e })}
                required
            />

            {/* DATE */}
            <Input
                id='date-of-bill'
                key='dateOfBill'
                name='date of bill'
                className='col-span-2 cursor-pointer lg:col-span-1'
                label='Fecha de compra'
                type='date'
                placeholder='14-05-2023'
                value={ticketValues.ticketDate}
                onChange={(e) =>
                    setTicketValues({
                        ...ticketValues,
                        ticketDate: e,
                    })
                }
                inputProps={{
                    min: minDate,
                    max: maxDate,
                }}
                required
            />

            {children && <div className='col-span-2 lg:order-last'>{children}</div>}

            <div className='col-span-2 my-6 flex flex-col justify-center gap-y-4 lg:flex-row lg:gap-x-10'>
                <Button
                    type='button'
                    variants='secondary'
                    size='md'
                    disabled={isLoading}
                    onClick={() => handleResetValues('ticket')}
                >
                    Limpiar
                </Button>
                <Button
                    type='submit'
                    size='md'
                    loading={isLoading}
                    disabled={Object.values(ticketValues).some((v) => v === '')}
                >
                    {ticketStatus && ticketStatus?.ticketFound && ticketStatus?.canRequest
                        ? 'Continuar'
                        : 'Consultar ticket'}
                </Button>
            </div>
        </form>
    );
};

FormInvoiceTicket.propTypes = {
    className: PropTypes.string,
    isLoading: PropTypes.bool,
    ticketStatus: PropTypes.object,
    handleConsultTicket: PropTypes.func,
    handleResetValues: PropTypes.func,
    children: PropTypes.node,
};

export default FormInvoiceTicket;
